var ezdia;
(function (ezdia) {
    var NAME = 'inputTab';
    var TYPE = 'inputTab';
    var DATA_TYPE = "ez." + TYPE;
    var JQUERY_NO_CONFLICT = $.fn[NAME];
    var DEFAULT = {
        rowSelector: '[data-row="inputTab"]',
        addBtnSelector: '[data-btn="add"]',
        removeBtnSelector: '[data-btn="remove"]',
        editBtnSelector: '[data-btn="edit"]',
        inputsSelector: '[data-input="input"]',
        inputContainer: '[data-container="inputTab"]',
        template: ezdia.templates.inputtab.mainTemplate,
        rowTemplate: ezdia.templates.inputtab.rowTemplate,
        trigger: 'click',
        editable: true,
        storageType: false,
        count: 0
    };
    // PRIVATE FUNCTIONS
    // =========================
    var getJson = function (str) {
        var obj = '';
        if (!str) {
            return null;
        }
        if (typeof str === 'string') {
            try {
                obj = ezdia.util.jsonParse(str);
            }
            catch (err) {
                obj = '';
            }
        }
        else {
            obj = str;
        }
        return obj;
    };
    // eslint-disable-next-line consistent-return
    var getDataObject = function (str) {
        if (!str) {
            return null;
        }
        var gotolabel = 'top';
        // eslint-disable-next-line camelcase
        gotoloop: while (gotolabel) {
            if (typeof str === 'string') {
                try {
                    // eslint-disable-next-line no-param-reassign
                    str = ezdia.util.jsonParse(str);
                    // eslint-disable-next-line no-extra-label
                    continue gotoloop;
                }
                catch (err) {
                    // eslint-disable-next-line no-param-reassign
                    str = '';
                    // tslint:disable-next-line:no-console
                    console.log(err);
                    break;
                }
            }
            else {
                return str;
            }
        }
    };
    function createHtmlEditor(obj) {
        var widget = {
            editor: {}
        };
        $.ezdia.html.init(widget.editor, obj);
        setTimeout(function () {
            $.ezdia.html.create(widget);
        }, 0);
    }
    function updateTabName(id, heading) {
        if (id) {
            // eslint-disable-next-line consistent-return
            $.each(this.tabNames, function (key, obj) {
                if (id === key && obj.value !== heading) {
                    $("#" + obj.id).text(heading);
                    obj.value = heading;
                    return false;
                }
            });
        }
        else {
            $.each(this.tabNames, function (key, obj) {
                if (obj.value) {
                    $("#" + obj.id).text(obj.value);
                }
            });
        }
    }
    var InputTab = /** @class */ (function () {
        function InputTab(elem, options) {
            this.elem = elem;
            this.emptyRow = false;
            this.init(options);
        }
        Object.defineProperty(InputTab.prototype, "Defaults", {
            get: function () {
                return DEFAULT;
            },
            enumerable: false,
            configurable: true
        });
        InputTab.prototype.getOptions = function (options) {
            return __assign(__assign(__assign({}, DEFAULT), this.$elem.data()), options);
        };
        InputTab.prototype.init = function (options) {
            this.$elem = $(this.elem);
            this.options = this.getOptions(options);
            this.$container = this.$elem.closest('[data-row="input"]');
            this.name = this.$elem.attr('id');
            this.data = this.$elem.val();
            this.emptyRow = true;
            this.currentRows = 0;
            this.tabNames = {};
            this.render();
        };
        InputTab.prototype.render = function () {
            var options = this.options;
            var config = options.fieldConfig
                ? getJson(options.fieldConfig)
                : null;
            if (!config) {
                return;
            }
            options.count = 0;
            this.currentRows = 0;
            this.fields = config.fields;
            $(this.elem)
                .wrap('')
                .hide()
                .closest('[data-row="row"]')
                .addClass('ez-input-tab');
            this.create();
            this.currentRows = this.options.count;
            updateTabName.call(this);
            this.bindEvents();
            this.onOffAddBtn();
        };
        InputTab.prototype.create = function () {
            var _this = this;
            var data = getDataObject(this.data);
            if (data && data.length) {
                this.emptyRow = false;
                $.each(data, function (i, obj) {
                    _this.createInputs(obj);
                });
            }
            else {
                this.createInputs();
            }
        };
        InputTab.prototype.createInputs = function (data) {
            var _this = this;
            var suffix = this.name + "-" + this.options.count;
            var init = this.options.count === 0;
            var context = {
                tabId: "ez-tab-input-" + suffix,
                bodyId: "ez-tab-input-body-" + suffix,
                headId: "ez-tab-input-head-" + suffix,
                headLabel: "ez-tab-input-head-label-" + suffix,
                href: "#ez-tab-input-body-" + suffix,
                init: init
            };
            var wrapper = this.options.template(context);
            var fields = this.fields;
            wrapper = $(wrapper);
            if (!data) {
                // eslint-disable-next-line no-param-reassign
                data = {};
            }
            $.each(fields, function (i, column) {
                column.id = column.name + _this.options.count;
                var template = _this.options.rowTemplate(column);
                var obj = {
                    column: column,
                    value: data[column.name] || ''
                };
                var inputs = null;
                if (column.name === 'tab_name') {
                    _this.tabNames[column.id] = {
                        value: obj.value,
                        id: context.headLabel
                    };
                }
                if (column.edittype === 'html') {
                    inputs = _this.html(obj);
                }
                else {
                    inputs = _this.input(obj);
                }
                template = $(template);
                template.find('[data-row="input"]').append(inputs);
                wrapper.find("#" + context.bodyId).append(template);
            });
            if (init) {
                this.$elem.after(wrapper);
                this.addbtn = this.$container.find('[data-row="add"]');
            }
            else {
                this.addbtn.before(wrapper);
            }
            this.validate();
            this.options.count += 1;
        };
        InputTab.prototype.bindEvents = function () {
            this.$container
                .on(this.options.trigger + "." + TYPE, this.options.addBtnSelector, $.proxy(this.addRow, this))
                .on(this.options.trigger + "." + TYPE, this.options.removeBtnSelector, $.proxy(this.removeRow, this))
                .on("blur." + TYPE, this.options.inputsSelector, $.proxy(this.update, this))
                .find(this.options.editBtnSelector)
                .on(this.options.trigger + "." + TYPE, $.proxy(this.editRow, this));
        };
        InputTab.prototype.addRow = function () {
            if (this.emptyRow) {
                return;
            }
            this.createInputs(null);
            this.currentRows += 1;
            this.emptyRow = true;
            this.onOffAddBtn();
        };
        // tslint:disable-next-line:no-empty
        InputTab.prototype.editRow = function () {
            //
        };
        InputTab.prototype.removeRow = function (e) {
            e.stopPropagation();
            var elem = $(e.currentTarget);
            var id = elem.data('id');
            if (this.currentRows === 1 && this.emptyRow) {
                return;
            }
            this.$container.find("#" + id).remove();
            this.update();
            this.currentRows -= 1;
            this.onOffAddBtn();
            if (this.currentRows === 0) {
                this.addRow();
            }
        };
        InputTab.prototype.onOffAddBtn = function () {
            var btn = this.$container.find(this.options.addBtnSelector);
            if (this.emptyRow) {
                btn.addClass('disabled');
            }
            else {
                btn.removeClass('disabled');
            }
        };
        InputTab.prototype.update = function () {
            var self = this;
            var rows = this.$container.find(this.options.rowSelector);
            var arr = [];
            var str = null;
            this.emptyRow = false;
            $.each(rows, function each() {
                var obj = self.getRowData($(this));
                var type = $(this).data('rowType');
                if (obj) {
                    arr.push(obj);
                }
                else if (!type && type !== 'remove') {
                    self.emptyRow = true;
                }
            });
            str = JSON.stringify(arr);
            $(this.elem).val(str).trigger('change');
            this.onOffAddBtn();
        };
        InputTab.prototype.getRowData = function (row) {
            var self = this;
            var options = this.options;
            var isData = false;
            var inputs = row.find(options.inputsSelector);
            var obj = {};
            $.each(inputs, function each() {
                var type = $(this).data('type');
                var name = $(this).data('name');
                var id = $(this).attr('id');
                var value = null;
                if (type === 'html') {
                    var txtarea = $("#" + this.id).is(':visible');
                    value = txtarea ? this.value : tinymce.get(this.id).getContent();
                }
                else {
                    value = this.value;
                }
                if (value && name === 'tab_name') {
                    updateTabName.call(self, id, value);
                }
                if (value) {
                    isData = true;
                }
                obj[name] = value;
            });
            return isData ? obj : null;
        };
        InputTab.prototype.validate = function () {
            var inputs = this.$container.find('[data-name="tab_name"]');
            var fields = this.fields;
            inputs.each(function each() {
                $(this).rules('add', {
                    required: function (el) {
                        var index = $(el).data('index');
                        var isempty = false;
                        // eslint-disable-next-line consistent-return
                        $.each(fields, function (i, column) {
                            var value = null;
                            var elem;
                            if (column.name === 'tab_name') {
                                return true;
                            }
                            // eslint-disable-next-line prefer-const
                            elem = $("#" + column.name + index);
                            value = elem.val();
                            if (value) {
                                isempty = true;
                                return false;
                            }
                        });
                        return isempty;
                    }
                });
            });
        };
        InputTab.prototype.refresh = function (data) {
            var options = this.options;
            var container = this.$container.find(options.inputContainer);
            this.$container.off("." + TYPE);
            container.remove();
            this.data = data || getJson(this.elem.value);
            this.render();
        };
        InputTab.prototype.destroy = function () {
            this.$elem.removeData("" + DATA_TYPE);
            this.$container.off("." + TYPE);
        };
        InputTab.prototype.input = function (obj) {
            var column = obj.column;
            var id = column.id, name = column.name, edittype = column.edittype, _a = column.placeholder, placeholder = _a === void 0 ? '' : _a, _b = column.config, config = _b === void 0 ? {} : _b;
            var _c = config.cssClass, cssClass = _c === void 0 ? '' : _c;
            var content = "<input type=\"text\"\n        id=\"" + id + "\"\n        name=\"" + id + "\"\n        placeholder=\"" + placeholder + "\"\n        value=\"" + (obj.value || '') + "\"\n        class=\"form-control " + cssClass + "\"\n        data-index=\"" + this.options.count + "\"\n        data-input=\"input\"\n        data-name=\"" + name + "\"\n        data-type=\"" + edittype + "\"\n      />";
            return content;
        };
        InputTab.prototype.textarea = function (obj) {
            var column = obj.column;
            var name = column.name, _a = column.id, id = _a === void 0 ? name : _a, edittype = column.edittype, _b = column.placeholder, placeholder = _b === void 0 ? '' : _b, _c = column.config, config = _c === void 0 ? {} : _c;
            var _d = config.cssClass, cssClass = _d === void 0 ? '' : _d, _e = config.rows, rows = _e === void 0 ? 4 : _e;
            var value = obj.value || '';
            var content = "<textarea\n        id=\"" + id + "\"\n        name=\"" + name + "\"\n        rows=\"" + rows + "\"\n        class=\"form-control " + cssClass + "\"\n        placeholder=\"" + placeholder + "\"\n        data-input=\"input\"\n        data-name=\"" + name + "\"\n        data-type=\"" + edittype + "\"\n        >" + value + "</textarea>";
            return content;
        };
        InputTab.prototype.html = function (obj) {
            var content = this.textarea(obj);
            createHtmlEditor.call(this, obj);
            return content;
        };
        return InputTab;
    }());
    /**
     * ------------------------------------------------------------------------
     * jQuery
     * ------------------------------------------------------------------------
     */
    var publicMethods = {
        // getValue: InputTab.prototype.getValue,
        refresh: InputTab.prototype.refresh,
        destroy: InputTab.prototype.destroy
    };
    function jQueryInterface(option) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (typeof option === 'string' && option !== 'destroy') {
            return invokePublicMethod.call(this, option, args);
        }
        return createNewInstance.call(this, option);
    }
    function invokePublicMethod(methodName, args) {
        if (publicMethods[methodName]) {
            var inputObject = retrieveObjectFromElement(this);
            var result = publicMethods[methodName].apply(inputObject, args);
            if (typeof result === 'undefined') {
                return $(this);
            }
            return result;
        }
        throw new Error("method '" + methodName + "()' does not exist for input list.");
    }
    // eslint-disable-next-line consistent-return
    function retrieveObjectFromElement(element) {
        var inputObject = $(element).data(DATA_TYPE);
        if (inputObject && inputObject instanceof InputTab) {
            return inputObject;
        }
    }
    function createNewInstance(option) {
        var $this = $(this);
        $this.each(function each() {
            var self = $(this);
            var data = self.data(DATA_TYPE);
            var options = typeof option === 'object' && option;
            if (!data) {
                self.data(DATA_TYPE, (data = new InputTab(this, options)));
            }
            if (typeof option === 'string') {
                data[option]();
            }
        });
        return $this;
    }
    $.fn[NAME] = jQueryInterface;
    $.fn[NAME].Constructor = InputTab;
    $.fn[NAME].noConflict = function noConflict() {
        $.fn[NAME] = JQUERY_NO_CONFLICT;
        return jQueryInterface;
    };
})(ezdia || (ezdia = {}));
